import { api } from "./api";

/**
 * Send a query to the chatbot and get a response
 * Works for both authenticated users and public visitors
 * @param {string} query - The user's question
 * @param {string} conversationId - Optional conversation ID to maintain context
 * @param {object} context - Optional context about current page/feature
 * @returns {Promise<{answer: string, confidence: number, conversation_id: string, suggested_actions: string[]}>}
 */
export async function chatbotQuery(query, conversationId = null, context = null) {
  try {
    // Check if user is authenticated (has token in localStorage)
    const hasToken = !!localStorage.getItem("orello_token");
    // Use public endpoint for unauthenticated users, authenticated endpoint for logged-in users
    const endpoint = hasToken ? "/chatbot/query" : "/chatbot/public";

    const response = await api.post(endpoint, {
      query,
      conversation_id: conversationId,
      context,
    });
    return response.data;
  } catch (error) {
    console.error("Chatbot query error:", error);
    throw error;
  }
}

/**
 * Get suggested questions based on current context
 * @param {string} feature - Current feature (e.g., "agreements", "deposits", "payments")
 * @returns {string[]} Array of suggested questions
 */
export function getSuggestedQuestions(feature = null) {
  const generalQuestions = [
    "What is Orello?",
    "How does it help tenants?",
    "How can landlords use it?",
    "What about agents and brokers?",
    "How do I get started?",
  ];

  const featureQuestions = {
    agreements: [
      "How to create a new agreement?",
      "What agreement types are available?",
      "How to sign an agreement?",
      "Can I modify an agreement?",
    ],
    deposits: [
      "How deposit protection works",
      "How to handle deposit deductions",
      "When does tenant get deposit back?",
      "What if landlord and tenant disagree on deductions?",
    ],
    payments: [
      "Why is my payment pending?",
      "How long does payment take?",
      "What payment methods are supported?",
      "Is there a payment limit?",
    ],
    slots: [
      "What are agreement slots?",
      "How to buy more slots?",
      "What happens when I run out of slots?",
      "Do slots expire?",
    ],
    billing: [
      "What's included in my plan?",
      "How to upgrade my plan?",
      "Can I downgrade my plan?",
      "What's the difference between monthly and yearly billing?",
    ],
  };

  if (feature && featureQuestions[feature]) {
    return featureQuestions[feature];
  }

  return generalQuestions;
}
